<template>
  <div>
    <component
      v-model="textModal"
      :is="componentName"
      :info="info.config"
      :commmonType="type"
      :index="index"
      @close="close"
      @add="add"
    ></component>
  </div>
</template>

<script>
import customTextType1 from "@components/custom-component/common/custom-text/components/custom-text-type-1.vue";
export default {
  // 文本类型 1
  name: "custom-text",
  model: {
    prop: "textModal",
    event: "sendTextModal"
  },
  props: {
    index: {
      type: Number,
      default: 0
    },
    textModal: {
      type: Object,
      default: function() {
        return {
          type: 1, // 文本类型 暂时只有 1
          content: "文本内容", // 文本内容
          fontSize: "16px", // 文字大小 （12px 14px 16px）===（大 中 小）
          color: "#000", // 文字颜色 默认黑色
          position: "left" // 文本对齐格式
        };
      }
    },
    info: {
      type: Object,
      default: {
        title: "文本",
        icon: "icon-wenbenbianji",
        type: "text",
        componentName: "customText",
        config: {
          type: 1, // 文本类型 暂时只有 1
          content: "", // 文本内容
          fontSize: "16px", // 文字大小 （12px 14px 16px）===（大 中 小）
          color: "#000", // 文字颜色 默认黑色
          position: "left" // 文本对齐格式
        }
      }
    },
    type: {
      // 通用添加组件的列表   1：所有列表   2：筛选列表
      type: Number,
      default: 1
    }
  },
  computed: {
    componentName() {
      return `customTextType${this.info.config.type}`;
    }
  },
  data() {
    return {};
  },
  components: {
    customTextType1
  },
  methods: {
    close() {
      this.$emit("close");
    },
    add(item, idx) {
      this.$emit("add", item, idx);
    }
  }
};
</script>

<style lang="scss">
.ivu-color-picker-confirm {
  .ivu-btn-small {
    margin-right: 5px;
  }
}
</style>
